// DEPENDENCIES
import React, { useState } from 'react';
import { useSpring, animated, styled } from 'react-spring';
// COMPONENTS
import { Link } from 'react-router-dom';

const Overlay = (props) => {

    const AnimatedLink = animated(Link);
    const animateShow = useSpring({ opacity: 1, from: { opacity: 0 } })
    const overlayDarknessOptions = {
        normal: "normal",
        dark: "dark"
    }

    return (
        <AnimatedLink
            className={`overlay ${props.overlayDarkness ? overlayDarknessOptions[props.overlayDarkness] : "normal"}`}
            style={animateShow}
            onClick={props.onClick ? props.onClick : () => { }}
        >
        </AnimatedLink>
    );
}

export default Overlay;